import { MdLocationOn } from "react-icons/md";

type Props = {
  lat: number;
  lng: number;
};

const LocationPin = (props: Props) => {
  return <MdLocationOn color="red" fontSize={'30px'} />;
};

export default LocationPin;
